export const isSSR = () => typeof window !== 'object'
